



















import {Component, Prop, Vue, Watch} from "vue-property-decorator";
class ProductCategory {
    product_id:number | null = null;
    cat_id:number | any = null;
}
@Component({})
export default class ProductCategoryListing extends Vue {
    @Prop({ required:true }) product_id!:number | null;
    @Prop({required:false ,default:"12"}) md!:string;
    @Prop({}) categories!:any;
    action: string = "productCategory/";
    items:ProductCategory[] = [];
    data:ProductCategory = new ProductCategory();
    ready:boolean = false;
    @Watch('cat_id')
    cat_idChanged(value: string, oldValue: string) {
        console.log("watch cat_id");
        this.get();
    }
    @Watch('items')
    itemsChanged(value: any, oldValue: any) {
        if(this.ready == false){
            return;
        }
        //console.log("new",value);
        //console.log("old",oldValue);
        if(value.length > oldValue.length){
            //console.log("eklenmis")
            let choosenItem = value[value.length-1];
            if(typeof  choosenItem == "object"){
                choosenItem = choosenItem.cat_id;
            }
            //console.log(choosenItem,value);
            this.data.cat_id = choosenItem
            this.data.product_id = this.product_id;
            this.add();
        }else{
            //console.log("silinmis",value)
            oldValue.forEach((ov:any)=>{
                if(typeof ov == "object"){
                    ov = ov.product_id;
                }
                let findVal = value.find((val:any)=> val == ov);
                //console.log({findVal});
                //console.log(ov);
                if(!findVal){
                    this.deleteItem(ov);
                    return;
                }
            })
        }
    }
    created(){
        this.ready = false;
        this.get();
    }
    async doEvent(e:Event){
        this.ready = true;
        console.log("doEvent");
    }
    async get(){
        let categoryLists = await this.$http.get(this.action + this.product_id);
        this.items = categoryLists.data;
    }
    async add(){
        try{
            let added = await this.$http.post(this.action,this.data);
            //this.get();
        }catch (e) {
            alert(e.message);
        }
        this.$emit("updateCategories",this.items);
    }

    async deleteItem(cat_id:string){
        try{
            let deleted = await this.$http.delete(this.action+this.product_id+"/"+cat_id);
        }catch (e) {
            console.log(e);
            //alert(e.message);
        }
        this.$emit("updateCategories",this.items);
    }
}
